import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { ConfigService } from '@rxap/config';
import { isUploadEnabled } from '../is-upload-enabled';
import { iirdsStore } from '../stores/iirds.store';
import { logGuardResult } from './guard-logger';

/**
 * Mirrors the viewer's `configGuard` upload-redirect: when uploading is
 * enabled and no content has been loaded yet, land the user on `/upload`
 * instead of the (otherwise empty) language/help screen. Once
 * `PortalArchiveSelectionStrategy` has merged at least one archive this
 * session, `iirdsStore.hasMergedArchives()` is true and this guard steps
 * aside so navigating back to `/iirds` doesn't bounce the user right back to
 * `/upload`.
 */
export const uploadDefaultGuard: CanActivateFn = () => {
  const configService = inject(ConfigService);
  const router = inject(Router);
  const iirds = inject(iirdsStore);

  if (iirds.hasMergedArchives()) {
    return logGuardResult('uploadDefaultGuard', true, {
      reason: 'archives already merged this session',
    });
  }

  if (!isUploadEnabled(configService)) {
    return logGuardResult('uploadDefaultGuard', true, {
      reason: 'upload disabled',
    });
  }

  return logGuardResult(
    'uploadDefaultGuard',
    new RedirectCommand(router.parseUrl('/upload')),
    { reason: 'upload enabled, no archives merged yet' }
  );
};
